import { ACL, ProjectService } from '../../../../types/entities';
import { MediaAsset } from '../../../../types/media-assets';
import i18n from '../../../../utils/i18n/i18n';
import { getURLSafeFilePath } from '../../../../utils/file/file-path';

const WIXMP_DOMAIN = '.wixmp.com';

export function withACLPrefix(text: string, acl: string | null): string {
  const prefixKey =
    acl === ACL.PRIVATE
      ? 'file-manager.file-info.common.acl.private'
      : 'file-manager.file-info.common.acl.public';

  return i18n.t(prefixKey, { text });
}

export function generateFilePathLink(
  fileService: ProjectService,
  file: MediaAsset,
): string {
  const isPrivateMediaBucket = file.bucket && file.bucket.includes('.');
  const shouldAddDomain = file.bucket && !isPrivateMediaBucket;

  return `https://${file.bucket || fileService.host}${
    shouldAddDomain ? WIXMP_DOMAIN : ''
  }${getURLSafeFilePath(file.path)}`;
}
